import { MODULE_NAME } from './const';
import { getGettersDeclarations, buildGetters } from '../../utils/widget-editor-module-generator/getters-generator';

export const {
	widget,
	widgetId,
	editField,
	widgetTitle,
	widgetFields,
	footerField,
	isSavingWidget,
	widgetMetadata,
	isLoadingWidgetFields,
	widgetFieldCredentials,
	widgetNodeId,
	widgetWorkflowVersionId,
} = getGettersDeclarations(MODULE_NAME);

const getters = buildGetters(MODULE_NAME);

export default getters;
